export default {
	namespaced: true,
	state: {
		windows: []
	},
	getters: {
		windows:	state => state.windows
	},
	actions: {
		push(c, win) {
			c.commit('PUSH', win);
			c.dispatch('pop/clear', {}, {
				root: true
			});
		},
		pop(c) {
			c.commit('POP');
			c.dispatch('pop/clear', {}, {
				root: true
			});
		}
	},
	mutations: {
		PUSH(state, win) {
			state.windows.push(win);
		},
		POP(state) {
			state.windows.pop();
		}
	}
};